import { RequirementChipProps } from "@/domains/certifications/components/types";

import "./styles.css";

const RequirementChip = ({ label, isMet }: RequirementChipProps) => (
  <span
    className={`requirement-chip body-xs-regular ${isMet ? "requirement-chip-met" : ""}`}
  >
    {label}
  </span>
);

export default RequirementChip;
